import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a33d9f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-items-center answer-box" }
const _hoisted_3 = { class: "tw-flex answer-box" }

import { Ref, onMounted, ref, watch } from "vue";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { assessmentAnswerType1State } from "@/utils/constants";
import SuggestionButton from "../common/suggestionButton.vue";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentAnswerType1',
  props: {
  value: {
    type: [Number, String],
    default: null,
  },
  suggestion: {
    type: Number,
    default: null,
  },
  onHover: {
    type: Boolean,
    default: true,
  },
  isWizardPage: {
    type: Boolean,
    default: false,
  },
  isTrue: {
    type: [String, Number],
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  excluded: {
    type: Boolean,
    default: false,
  },
  colorCheckBox: {
    type: String,
    default: "#387DFF",
  },
  textCheckboxLeft: {
    type: String,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
    ),
  },
  textCheckboxRight: {
    type: String,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
    ),
  },
  id: {
    type: String,
    default: "",
  },
},
  emits: ["onUpdate", "update:value"],
  setup(__props, { emit: emits }) {

const props = __props;




// const state: Ref = ref(assessmentAnswerType1State.unselected);
const state: Ref = ref(props.isTrue);
const handleState = (value: number | string) => {
  if (props.disabled) return;
  if (props.value !== null && !state.value && !isMounted) return;
  state.value = value;
  emits("onUpdate", value);
  emits("update:value", value);
};

let isMounted = false;
onMounted(() => {
  setTimeout(() => {
    isMounted = true;
  }, 500);
});

watch(
  () => props.isTrue,
  (newValue, oldValue) => {
    if (newValue) {
      state.value = newValue;
      handleState(newValue);
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass([`${__props.isWizardPage ? 'wizard-page' : 'assessment-page'} ${
      __props.disabled ? 'tw-opacity-50' : ''
    }`, "tw-flex tw-items-start tw-justify-start tw-w-[fit-content] tw-flex-wrap"])
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(BaseCheckbox, {
        text: __props.textCheckboxLeft,
        class: _normalizeClass(`${__props.disabled ? 'tw-pointer-events-none' : ''}`),
        "data-cy": "base-checkbox-option-yes",
        color: __props.excluded || __props.disabled ? '#DBDBDB' : __props.colorCheckBox,
        ticked: __props.value === _unref(assessmentAnswerType1State).yes,
        disabled: __props.isTrue,
        "is-check-cursor": __props.disabled,
        onSelected: _cache[0] || (_cache[0] = () => handleState(_unref(assessmentAnswerType1State).yes)),
        onUnselected: _cache[1] || (_cache[1] = () => handleState(_unref(assessmentAnswerType1State).unselected))
      }, null, 8, ["text", "class", "color", "ticked", "disabled", "is-check-cursor"]),
      (__props.suggestion === _unref(assessmentAnswerType1State).yes)
        ? (_openBlock(), _createBlock(SuggestionButton, {
            key: 0,
            style: _normalizeStyle({
          visibility: __props.onHover ? 'visible' : 'hidden',
        }),
            onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (handleState(_unref(assessmentAnswerType1State).yes)))
          }, null, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_3, [
      _createVNode(BaseCheckbox, {
        text: __props.textCheckboxRight,
        color: __props.excluded || __props.disabled ? '#DBDBDB' : __props.colorCheckBox,
        "data-cy": "base-checkbox-option-no",
        disabled: __props.isTrue,
        "is-check-cursor": __props.disabled,
        ticked: __props.value === _unref(assessmentAnswerType1State).no,
        onSelected: _cache[3] || (_cache[3] = () => handleState(_unref(assessmentAnswerType1State).no)),
        onUnselected: _cache[4] || (_cache[4] = () => handleState(_unref(assessmentAnswerType1State).unselected))
      }, null, 8, ["text", "color", "disabled", "is-check-cursor", "ticked"]),
      (__props.suggestion === _unref(assessmentAnswerType1State).no)
        ? (_openBlock(), _createBlock(SuggestionButton, {
            key: 0,
            style: _normalizeStyle({
          visibility: __props.onHover ? 'visible' : 'hidden',
        }),
            "css-style": 'tw-bg-[linear-gradient(0deg,_rgba(254,_154,_5,_0.15)_0%,_rgba(254,_154,_5,_0.15)_100%)]',
            onOnClicked: _cache[5] || (_cache[5] = ($event: any) => (handleState(_unref(assessmentAnswerType1State).no)))
          }, null, 8, ["style", "css-style"]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})